import React, { Component } from 'react';
import { Steps, Breadcrumb, Layout } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import SelectorModelo from '../tramites/formularios/SelectorModelo';
import Generador from '../generador/Generador';
import CKEditor from '../editor/Example';

import { imprimir } from '../common/funciones/imprimir';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

class ReImprimirNota extends Component {
  state = {
    nota: {
      idModeloNota: '',
      titulo: '',
      descripcion: '',
      htmlModelo: '',
    },
    step: 0,
    guardado: false,
  };

  componentDidMount() {
    // console.log("DID MOUNT");
    // console.log(this.props);
    if (this.props.idModeloNota) {
      this.setState(
        {
          ...this.state,
          nota: {
            ...this.state.nota,
            idModeloNota: this.props.idModeloNota,
          },
        },
        function() {
          // console.log("Datos actualizados!")
          this.siguientePaso();
        }
      );
    }
  }

  notaSeleccionada = idNota => {
    this.setState({
      ...this.state,
      nota: {
        idModeloNota: idNota,
      },
    });
  };

  finProcesoGeneracion = textoGenerado => {
    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          htmlModelo: textoGenerado,
        },
      },
      () => {
        this.siguientePaso();
      }
    );
  };

  siguientePaso = () => {
    //Metodo que se encarga de aumentar en 1 el paso y es llamado por todos los metodos auxiliares
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  };

  anteriorPaso = () => {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  render() {
    const { Step } = Steps;
    let { step } = this.state;
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Tramites</Breadcrumb.Item>
          <Breadcrumb.Item>Re Imprimir</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Imprimir Nota
          </h2>
          <br />
          <Steps size="small" className="stepsFormularios" current={step}>
            <Step title="Modelo Nota" />
            <Step title="Generacion de Nota" />
            <Step title="Editar e Imprimir" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <SelectorModelo
                handleChange={this.notaSeleccionada}
                onSubmit={this.siguientePaso}
              />
            )}
            {step === 1 && (
              <Generador
                id={this.state.nota.idModeloNota}
                // datos={this.state.persona}
                datos={this.props.datos}
                mostrarEditor={this.finProcesoGeneracion}
              />
            )}
            {step === 2 && (
              <CKEditor
                modelo_nota={this.state.nota}
                onImprimir={imprimir}
                onCancel={this.props.onCancel}
                accion="imprimir"
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default ReImprimirNota;
